import React from 'react';
import { Typography } from '@material-ui/core';
import deliveryIcon from '../../../images/delivery_icon.svg';
import locationIcon from '../../../images/location_icon.svg';
import walletIcon from '../../../images/wallet_icon.svg';
import cardsImg from '../../../images/cards_s.png';
import s from './DeliveryPayment.module.scss';

const DeliveryPayment = props => {
  const { t } = props;

  return (
    <>
      <div className={s.delivery}>
        <Typography variant="h6">
          <img src={locationIcon} alt="" />
          {t['Самовывоз бесплатно']}
        </Typography>
        <ul>
          <li>{t['г. Москва, Варшавское шоссе, д. 125']}</li>
          <li>{t['г. Дубна, ул. Программистов, д. 4']}</li>
        </ul>
        <Typography variant="h6">
          <img src={deliveryIcon} alt="" />
          {t['Доставка от...']}
        </Typography>
        <ul>
          <li>{t['Почта России']}</li>
          <li>{t['Курьерская служба CDEK']}</li>
          <li>
            {t['ПВЗ boxberry']} ({t['бесплатно при заказе любого прибора']})
          </li>
        </ul>
      </div>
      <div className={s.payment}>
        <Typography variant="h6">
          <img src={walletIcon} alt="" />
          {t['Оплата']}
          <img src={cardsImg} alt="" className={s.rightImg} />
        </Typography>
        <ul>
          <li>{t['Онлайн на сайте']}</li>
          <li>{t['Наличными при получении']}</li>
        </ul>
      </div>
    </>
  );
};

export default DeliveryPayment;
